import React from 'react';

import { format } from 'date-fns';
import { MdCalendarToday } from 'react-icons/md';
import { useSelector } from 'react-redux';
import EmptyOptimization from '../../../../../../../../../assets/image/empty-optimization.svg';
import { Skeleton } from '../../../../../../../../../components';
import { optimizationPricesResultSelector } from '../../../../../../../../../reducers/OtimizacaoPrecos';
import { styleFormat } from '../../../../../../../../../utils/FormatNumbers';
import { useResult } from '../../../../../../hooks/useResult';
import { IAComponent } from '../../../../../OtimizacaoPrecos/components/CoordinateSection/ia';
import { BigNumbers } from '../../../BigNumbers';
import { ChartProjectionOptmizated } from '../../../ChartProjectionOptmizated';
import { FilterStore } from '../../../FilterStore/FilterStore';
import styles from './OptimizationForecastTab.module.scss';

const optionsPercent = {
  style: 'percent' as styleFormat,
  options: {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    showSuffix: true,
  },
};

const optionsDecimal = {
  style: 'decimal' as styleFormat,
  options: {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    showSuffix: false,
  },
};

const optionsCurrency = {
  style: 'currency' as styleFormat,
  options: {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    showSuffix: true,
  },
};
export const OptimizationForecastTab = () => {
  const { tabs, result } = useSelector(optimizationPricesResultSelector);
  const {
    isLoadingResultBigNumbers,
    handleSelectStoreId,
    storesSelected,
    stores,
    hasOptimization,
    nextOptimization,
    isLoadingResult,
    isLoadingResultChartData,
    hasResult,
  } = useResult();
  const nextOptimizationDate = nextOptimization ? format(new Date(nextOptimization), 'dd/MM/yyyy') : null;

  const { margin, competitiveness, salesVolume, revenue, profitForecast, endDate, startDate } = tabs.forecast.bigNumbers;

  const storesIdWithoutResults = result.storesIdWithoutResults;
  return (
    <main className={styles.container}>
      {isLoadingResult ? <Skeleton width={'100%'} height={440} /> : null}

      {!isLoadingResult && hasOptimization && (
        <>
          {hasResult && (
            <section className={styles['big-numbers-container']}>
              <div className={styles['title-container']}>
                <span className={styles.title}>Previsão de preço otimizado</span>
                <span className={styles.subtitle}>Cenário otimizado projetado com IA na data de criação da estratégia.</span>
              </div>
              <div className={styles.period}>
                <div>
                  <span className={styles.label}>Período: </span>

                  {isLoadingResultBigNumbers ? (
                    <Skeleton width={140} height={20} />
                  ) : (
                    <span className={styles.date}>
                      <MdCalendarToday />
                      {startDate} ~ {endDate}
                    </span>
                  )}
                </div>

                <div>
                  <span className={styles.label}>Loja otimização: </span>
                  <FilterStore
                    handleSelectStoreId={handleSelectStoreId}
                    selectedStoresId={storesSelected}
                    stores={stores}
                    storesIdWithoutResults={storesIdWithoutResults}
                  />
                </div>
              </div>
              <div className={styles['big-numbers']}>
                <BigNumbers
                  isLoading={isLoadingResultBigNumbers}
                  styleNumber={optionsPercent}
                  mainValue={margin?.optimizedValue}
                  variation={margin?.differencePercentage}
                  description="Margem otimizada"
                  oldValue={margin?.value}
                  positiveVariation={margin?.differencePercentage >= 0}
                />
                <BigNumbers
                  isLoading={isLoadingResultBigNumbers}
                  styleNumber={optionsPercent}
                  mainValue={competitiveness?.optimizedValue}
                  variation={competitiveness?.differencePercentage}
                  description="Competitividade otimizada"
                  oldValue={competitiveness?.value}
                  positiveVariation={competitiveness?.differencePercentage >= 0}
                />
                <BigNumbers
                  isLoading={isLoadingResultBigNumbers}
                  styleNumber={optionsDecimal}
                  mainValue={salesVolume?.optimizedValue}
                  variation={salesVolume?.differencePercentage}
                  description="Volume venda otimizado"
                  oldValue={salesVolume?.value}
                  positiveVariation={salesVolume?.differencePercentage >= 0}
                />
                <BigNumbers
                  isLoading={isLoadingResultBigNumbers}
                  styleNumber={optionsCurrency}
                  mainValue={revenue?.optimizedValue}
                  variation={revenue?.differencePercentage}
                  description="Receita otimizada"
                  oldValue={revenue?.value}
                  positiveVariation={revenue?.differencePercentage >= 0}
                />
                <BigNumbers
                  isLoading={isLoadingResultBigNumbers}
                  styleNumber={optionsCurrency}
                  mainValue={profitForecast?.optimizedValue}
                  variation={profitForecast?.differencePercentage}
                  description="Previsão de lucro otimizado"
                  oldValue={profitForecast?.value}
                  positiveVariation={profitForecast?.differencePercentage >= 0}
                  highlight
                />
              </div>
            </section>
          )}

          {hasResult ? (
            <div className={styles['ia-container']}>
              <IAComponent />
              <p>
                Nossa projeção usa inteligência artificial e dados estratégicos para oferecer o melhor cenário de precificação, podendo haver pequenas
                variações.
              </p>
            </div>
          ) : null}

          <div>
            <ChartProjectionOptmizated isLoadingResultChartData={isLoadingResultChartData} hasResult={hasResult} />
          </div>
        </>
      )}

      {!isLoadingResult && !hasOptimization && (
        <div className={styles.empty}>
          <span className={styles.title}>Em breve sua Otimização de preços estará disponível.</span>
          <span className={styles.subtitle}>No dia {nextOptimizationDate}, você poderá acessá-la com todas as informações atualizadas.</span>
          <img src={EmptyOptimization} alt="" />
        </div>
      )}
    </main>
  );
};
